import {
    clearUamAuthToken,
    removeSpiceData,
    setAuthData,
    setGamData,
    setSpiceData,
    setUamData,
} from '../../state/ducks/auth';
import {
    makeSelectAccessToken,
    makeSelectAccessTokenData,
    makeSelectAuthUsername,
    makeSelectConsumerId,
    makeSelectRefreshToken,
    makeSelectSpiceToken,
} from '../../state/selectors/auth';
import {dispatch, getState} from '../../state/store';

const getAccessToken = () => makeSelectAccessToken()(getState());
const getAccessTokenData = () => makeSelectAccessTokenData()(getState());
const getAuthUsername = () => makeSelectAuthUsername()(getState());
const getRefreshToken = () => makeSelectRefreshToken()(getState());
const getSpiceToken = () => makeSelectSpiceToken()(getState());
const getConsumerId = () => makeSelectConsumerId()(getState());
const setUamApiData = (uamData) => dispatch(setUamData(uamData));
const setGamApiData = (isHolder, authToken) => dispatch(setGamData(isHolder, authToken));
const clearUamApiToken = (isHolder) => dispatch(clearUamAuthToken(isHolder));
const removeSpiceApiData = () => dispatch(removeSpiceData());

const setIccTokenData = (data) => {
    dispatch(setAuthData(data));
};

const setSpiceToken = (token, username) => {
    dispatch(setSpiceData(token, username));
};

export default {
    clearUamApiToken,
    getAccessToken,
    getAccessTokenData,
    getAuthUsername,
    getConsumerId,
    getRefreshToken,
    getSpiceToken,
    setIccTokenData,
    setSpiceToken,
    setUamApiData,
    setGamApiData,
    removeSpiceApiData,
};
